(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinki-das-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pd-image-slider')) {
  customElements.define('pd-image-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.pd-slider__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pauseButton = this.querySelector('.pd-slider__pause');
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.start(); }, options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.syncPause(); this.start(); }, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); }, options);
      this.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); } }, options);
      this.addEventListener('touchstart', (event) => { this.touchX = event.touches[0].clientX; this.stop(); }, { ...options, passive: true });
      this.addEventListener('touchend', (event) => { const delta = event.changedTouches[0].clientX - this.touchX; if (Math.abs(delta) > 45) this.show(this.index + (delta < 0 ? 1 : -1)); this.start(); }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), options);
      this.addEventListener('shopify:block:select', (event) => { const index = this.slides.indexOf(event.target.closest('.pd-slider__slide')); if (index >= 0) this.show(index); this.stop(); }, options);
      this.addEventListener('shopify:block:deselect', () => this.start(), options);
      this.syncPause(); this.start();
    }
    disconnectedCallback() { this.stop(); this.abort.abort(); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
      this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.index)));
    }
    syncPause() {
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
    }
    stop() { window.clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.slides.length > 1 && !this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.timer = window.setInterval(() => this.show(this.index + 1), 6000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
